import { computed, ComputedRef } from 'vue'
import { useMetaDiscount } from './useMetaDiscount'
import { validateMetaDiscountParticipantFile } from '../../../dependency-injection'

export interface IUseMetaDiscountSellers {
  sellers: ComputedRef<number[]>
  hasSellers: ComputedRef<boolean>
  setSellers: (sellers: number[]) => void
}

export const parseSellerIdsFromFile = async (csvFile: File): Promise<number[]> => {
  return validateMetaDiscountParticipantFile.execute(csvFile)
}

export const useMetaDiscountSellers = (): IUseMetaDiscountSellers => {
  const { sellers, setParticipation } = useMetaDiscount()

  const hasSellers = computed(() => Boolean(sellers.value.length))

  return {
    sellers,
    hasSellers,
    setSellers: setParticipation,
  }
}
